<template>
    <div class="user-detail">
        <v-container>
            <v-card>
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">{{$t('release.release')}}
                </v-card-title>
                <v-card-text>
                    <v-form v-model="valid">
                        <v-text-field v-bind:label="$t('release.revision')"
                                      v-model="form.attributes.revision"></v-text-field>
                        <v-autocomplete
                                v-model="form.relationships['maintainer'].data"
                                :items="maintainer"
                                v-bind:label="$t('user.department')"
                                item-text="attributes.title"
                                item-value="id"
                                return-object
                        ></v-autocomplete>

                        <v-btn v-if="!(form.attributes.locked == true)" color="primary" @click="saveAction">
                            {{$t('message.save')}}
                        </v-btn>
                        <v-btn v-if="$gate.can('lock_releases') && !(form.attributes.locked == true)" color="danger"
                               @click="lockAction(form.id)">{{$t('message.lock')}}
                        </v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
            <v-layout>
                <v-flex sm12 class="mt-4" v-if="showImageWidget">
                    <v-card>
                        <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                            {{$t('release.actual_revision')}}
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <div v-for="item, index in form.relationships['release-images'].data">
                            <div v-if="index == form.relationships['release-images'].data.length - 1">
                                <pdf ref="pdf" :src="item.attributes.base64"></pdf>
                                <v-btn primary @click="downloadPDF(item.attributes.base64, form.attributes.revision + '.pdf')">Download</v-btn>
                            </div>
                        </div>
                        <v-list>
                            <v-card-title style="background-color: rgb(33, 57, 141); color: white;"
                                          v-if="$gate.can('create_releaseImages') && !(form.attributes.locked == true)">
                                {{$t('release.protocol')}}
                            </v-card-title>
                            <v-list-tile v-for="item, index in form.relationships['release-images'].data"
                                         :key="index">
                                <v-list-tile-content>
                                    <v-list-tile-title v-text="item.attributes.comment"></v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-card-title style="background-color: rgb(33, 57, 141); color: white;"
                                      v-if="!(form.attributes.locked == true)">
                            {{$t('release.new_image_revision')}}
                        </v-card-title>
                        <v-card-text v-if="!(form.attributes.locked == true)">
                            <dennis-uploader
                                    v-bind:placeholder="$t('release.upload_image')"
                                    accept="application/pdf" :max-size="customImageMaxSize"
                                    @size-exceeded="onSizeExceeded" @file="onFile" @load="onLoad" previewImage="false"/>
                            <v-textarea v-bind:label="$t('release.comment')"
                                        v-model="imageForm.attributes.comment"></v-textarea>
                            <v-btn @click="saveImageAction(form.id)" v-if="$gate.can('newRevision_releaseImages')">{{$t('message.newRevision')}}</v-btn>
                            <v-btn @click="saveImageToMaintainerAction(form.id)" v-if="$gate.can('release_toMaintain') && form.attributes.need_maintainer == 0">{{$t('message.reportIssue')}}</v-btn>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout>

                <v-flex sm4 class="mt-4" v-if="showProductWidget">
                    <v-card>
                        <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                            {{$t('product.product')}}
                        </v-card-title>
                        <v-card-text>
                            <v-text-field
                                    v-model="form.relationships['products'].data.attributes.number"
                                    v-bind:label="$t('product.number')"
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.relationships['products'].data.attributes.customer_number"
                                    v-bind:label="$t('product.customer_number')"
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.relationships['products'].data.attributes.description"
                                    v-bind:label="$t('product.description')"
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.relationships['products'].data.attributes.extra_description"
                                    v-bind:label="$t('product.extra_description')"
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.relationships['products'].data.attributes.extra_dimension"
                                    v-bind:label="$t('product.extra_dimension')"
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.relationships['products'].data.attributes.material"
                                    v-bind:label="$t('product.material')"
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.relationships['products'].data.attributes.width"
                                    v-bind:label="$t('product.width')"
                                    suffix="mm"
                            ></v-text-field>
                            <v-text-field
                                    v-model="form.relationships['products'].data.attributes.height"
                                    v-bind:label="$t('product.height')"
                                    suffix="mm"
                            ></v-text-field>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex sm8 class="mt-4 ml-4" v-if="showHistoryWidget">
                    <v-card>
                        <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                            {{$t('releaseFlow.releaseFlow')}}
                        </v-card-title>
                        <v-list>
                            <v-list-tile v-for="item, index in form.relationships['release-histories'].data"
                                         :key="index" @click="">
                                <v-list-tile-content>
                                    <v-list-tile-title v-text="item.attributes.title"></v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="!(form.attributes.locked == true) && false">
                                    <v-btn icon :to="{ name: 'release-step-history', params: { id: item.id }}">
                                        <v-icon color="primary">comment</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                                <v-list-tile-action>
                                    <v-btn icon @click="releaseAction(item.id)"
                                           v-if="$gate.can('release_releaseHistories') && $user.inDepartmentById(item.attributes.departments_id) && item.attributes.start_date && !item.attributes.veryfied_date">
                                        <v-icon color="blue">check</v-icon>
                                    </v-btn>
                                    <v-icon color="red"
                                            v-if="!item.attributes.veryfied_date  && !item.attributes.start_date">close
                                    </v-icon>
                                    <v-icon color="green" v-if="item.attributes.veryfied_date">check</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>

                    </v-card>
                </v-flex>

            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import DennisUploader from '@/components/DennisUploader.vue'; // @ is an alias to /src
    import pdf from 'vue-pdf'

    export default {
        components: {
            DennisUploader,
            pdf
        },
        mounted() {

            this.$store.dispatch('departments/loadAll').then(() => {
                const widgets = this.$store.getters['departments/all'];
                widgets.forEach((item) => {
                    this.maintainer.push(item);
                });
            });

            if (this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('releases/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['releases/byId']({id: this.id});
                    this.form.attributes = widget.attributes;
                    this.form.id = widget.id;
                    this.form.type = widget.type;
                    const parent = widget;
                    this.$store.dispatch('products/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['products/related']({parent});
                        this.form.relationships['products'] = {data: {}};
                        this.form.relationships['products'].data = related;
                        this.showProductWidget = true;
                    });

                    this.$store.dispatch('maintainer/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['maintainer/related']({parent});
                        this.form.relationships['maintainer'] = {data: {}};
                        this.form.relationships['maintainer'].data = related;
                        this.showProductWidget = true;
                    });

                    this.$store.dispatch('releaseHistories/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['releaseHistories/related']({parent});
                        this.form.relationships['release-histories'] = {data: []};
                        this.form.relationships['release-histories'].data = related;
                        console.log(this.form.relationships['release-histories']);
                        this.showHistoryWidget = true;
                    });

                    this.$store.dispatch('releaseImages/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['releaseImages/related']({parent});
                        this.form.relationships['release-images'] = {data: []};
                        this.form.relationships['release-images'].data = related;
                        console.log(this.form.relationships['release-images']);
                        this.showImageWidget = true;
                    });

                });
            } else {
                alert('no id error');

            }

        },
        methods: {

            ...mapActions({
                delete: 'releases/delete',
            }),

            saveImageToMaintainerAction(id) {

                const recordData = {
                    attributes: {
                        base64: this.imageForm.attributes.base64,
                        release_id: this.$route.params.id,
                        comment: this.imageForm.attributes.comment,
                    },
                };

                this.$store.dispatch('releaseImages/create', recordData).then(() => {
                    var widget = {};
                    widget.attributes = this.form.attributes;
                    widget.id = this.form.id;
                    widget.type = this.form.type;
                    const parent = widget;
                    this.$store.dispatch('releaseImages/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['releaseImages/related']({parent});
                        this.form.relationships['release-images'].data = [];
                        this.form.relationships['release-images'].data = related;
                    });

                    var widget = this.$store.getters['releases/byId']({id: id});

                    const httpClient = this.axios.create({
                        baseURL: process.env.VUE_APP_API,
                        headers: {'Content-Type': 'application/vnd.api+json'},
                    });

                    httpClient.post('releases/' + id + '/needMaintainer', widget).then((response) => {
                        this.$router.go();
                    });

                });



            },

            downloadPDF(pdf, fileName) {
                const linkSource = pdf;
                const downloadLink = document.createElement("a");

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }
            ,

            releaseAction: function (historyId) {

                var widget = this.$store.getters['releaseHistories/byId']({id: historyId});

                const httpClient = this.axios.create({
                    baseURL: process.env.VUE_APP_API,
                    headers: {'Content-Type': 'application/vnd.api+json'},
                });

                httpClient.post('release-histories/' + historyId + '/release', widget).then((response) => {
                    this.$router.go();
                })

            }
            ,

            saveAction: function () {
                if (this.$route.params.id != null) {
                    //this.form.id = this.$route.params.id;
                    var widget = this.$store.getters['releases/byId']({id: this.form.id});
                    widget = this.form;

                    delete widget.relationships['maintainer'].data.relationships;
                    delete widget.relationships['maintainer'].data.attributes;
                    delete widget.relationships['maintainer'].data.links;

                    delete widget.relationships['products'].data.relationships;
                    delete widget.relationships['products'].data.attributes;
                    delete widget.relationships['products'].data.links;

                    widget.relationships['release-histories'].data.forEach(function (item) {
                        delete item.relationships;
                        delete item.attributes;
                        delete item.links;
                        return item;
                    });

                    widget.relationships['release-images'].data.forEach(function (item) {
                        delete item.relationships;
                        delete item.attributes;
                        delete item.links;
                        return item;
                    });

                    this.$store.dispatch('releases/update', widget).then(() => {
                        this.$router.back();
                    });
                } else {
                    var widget = this.form;

                    //widget.relationships['maintainer'].data.forEach(function (item) {
                    //    delete item.relationships;
                    //    delete item.attributes;
                    //    delete item.links;
                    //    return item;
                    //});
                    //if(widget.relationships['maintainer'].data[0] !== undefined)
                    //    if (widget.relationships['maintainer'].data[0].type == undefined)
                    //        delete widget.relationships['maintainer'];

                    this.$store.dispatch('releases/create', widget).then(() => {
                        this.$router.back();
                    });
                }
            }
            ,

            saveImageAction: function (id) {
                const recordData = {
                    attributes: {
                        base64: this.imageForm.attributes.base64,
                        release_id: this.$route.params.id,
                        comment: this.imageForm.attributes.comment,
                    },
                };
                this.$store.dispatch('releaseImages/create', recordData).then(() => {
                    var widget = {};
                    widget.attributes = this.form.attributes;
                    widget.id = this.form.id;
                    widget.type = this.form.type;
                    const parent = widget;
                    this.$store.dispatch('releaseImages/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['releaseImages/related']({parent});
                        this.form.relationships['release-images'].data = [];
                        this.form.relationships['release-images'].data = related;
                    });

                    if(this.form.attributes.need_maintainer) {
                        var widget = this.$store.getters['releases/byId']({id: id});

                        const httpClient = this.axios.create({
                            baseURL: process.env.VUE_APP_API,
                            headers: {'Content-Type': 'application/vnd.api+json'},
                        });

                        httpClient.post('releases/' + id + '/unneedMaintainer', widget).then((response) => {
                            this.$router.go();
                        });
                    }

                });
            }
            ,

            lockAction: function (id) {
                var widget = this.$store.getters['releases/byId']({id: id});

                const httpClient = this.axios.create({
                    baseURL: process.env.VUE_APP_API,
                    headers: {'Content-Type': 'application/vnd.api+json'},
                });

                httpClient.post('releases/' + id + '/lock', widget).then((response) => {
                    this.$router.go();
                });
            }
            ,

            onFile(file) {

            }
            ,

            onLoad(dataUri) {
                this.imageForm.attributes.base64 = dataUri;
            }
            ,

            onSizeExceeded(size) {
                alert(`Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`);
            }
            ,

        },
        computed: {
            ...
                mapGetters({
                    loading: "releases/isLoading",
                    error: "releases/isError",
                }),
        }
        ,
        data: () => ({
            lastImage: '',
            customImageMaxSize: 3,
            file: '',
            files: '',
            form: {
                attributes: {
                    title: '',
                },
                relationships: {
                    'maintainer': {data: []},
                },
            },
            imageForm: {
                attributes: {
                    comment: '',
                    base64: '',
                }
            },
            showHistoryWidget: false,
            showProductWidget: false,
            showImageWidget: false,
            image: '',
            valid: false,
            id: null,
            title: '',
            titleRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ],
            releaseFlows: [],
            products: [],
            maintainer: [],
        })
    }
</script>
